import { render, staticRenderFns } from "./Item66AbamaRequest.vue?vue&type=template&id=054322a8&"
import script from "./Item66AbamaRequest.vue?vue&type=script&lang=js&"
export * from "./Item66AbamaRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports